import {createSelector} from 'reselect';
import {Store} from '../../redux/reducers';
import {initialState} from './reducer';

const select = (state: Store) => state.reports || initialState;

const makeSelectReportCurrentOrderslist = () =>
  createSelector(select, substate => substate.reportCurrentOrdersList);

const makeSelectReportCenterOrderslist = () =>
  createSelector(select, substate => substate.reportCenterOrdersList);

const makeSelectLoading = () =>
  createSelector(select, substate => substate.loading);

const makeSelectError = () =>
  createSelector(select, substate => substate.error);

export default select;
export {
  makeSelectReportCurrentOrderslist,
  makeSelectLoading,
  makeSelectError,
  makeSelectReportCenterOrderslist,
};
